import { render, staticRenderFns } from "./PoweredBy.vue?vue&type=template&id=aafa31a6&scoped=true"
import script from "./PoweredBy.vue?vue&type=script&lang=js"
export * from "./PoweredBy.vue?vue&type=script&lang=js"
import style0 from "./PoweredBy.vue?vue&type=style&index=0&id=aafa31a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafa31a6",
  null
  
)

export default component.exports